"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flashMessageService = exports.makeFlashMessageService = void 0;
function makeFlashMessageService() {
    let flashMessages = [];
    let subscribers = [];
    return {
        addFlashMessage,
        removeFlashMessage,
        clearFlashMessages,
        getFlashMessages,
        subscribe,
        unsubscribe
    };
    function addFlashMessage(flashMessage) {
        flashMessages.push(flashMessage);
        informSubscribers();
    }
    function removeFlashMessage(flashMessage, reason) {
        const remainingFlashMessages = [];
        flashMessages.forEach((f) => {
            if (f !== flashMessage) {
                remainingFlashMessages.push(f);
            }
            else {
                f.onRemove(reason);
            }
        });
        flashMessages = remainingFlashMessages;
        informSubscribers();
    }
    function clearFlashMessages() {
        flashMessages = [];
        informSubscribers();
    }
    function getFlashMessages() {
        return flashMessages;
    }
    function subscribe(subscriber) {
        subscribers.push(subscriber);
        subscriber(flashMessages);
    }
    function unsubscribe(subscriber) {
        subscribers = subscribers.filter((s) => s !== subscriber);
    }
    function informSubscribers() {
        subscribers.forEach((subscriber) => subscriber([...flashMessages]));
    }
}
exports.makeFlashMessageService = makeFlashMessageService;
exports.flashMessageService = makeFlashMessageService();
